/* tslint:disable */
/* eslint-disable */
/**
 * Westbury Music API Admin
 * API for Westbury Music admin users
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LinkReleaseRequest
 */
export interface LinkReleaseRequest {
    /**
     * ParentRelease id from lookup
     * @type {string}
     * @memberof LinkReleaseRequest
     */
    releaseId: string;
    /**
     * 
     * @type {string}
     * @memberof LinkReleaseRequest
     */
    dateReleased?: string | null;
    /**
     * If already linked, from lookup response
     * @type {string}
     * @memberof LinkReleaseRequest
     */
    edgeId?: string | null;
    /**
     * Release title from lookup
     * @type {string}
     * @memberof LinkReleaseRequest
     */
    releaseTitle: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof LinkReleaseRequest
     */
    releaseLabels?: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof LinkReleaseRequest
     */
    catNumbers?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof LinkReleaseRequest
     */
    mediaType?: string;
    /**
     * 
     * @type {string}
     * @memberof LinkReleaseRequest
     */
    format?: string;
}

/**
 * Check if a given object implements the LinkReleaseRequest interface.
 */
export function instanceOfLinkReleaseRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "releaseId" in value;
    isInstance = isInstance && "releaseTitle" in value;

    return isInstance;
}

export function LinkReleaseRequestFromJSON(json: any): LinkReleaseRequest {
    return LinkReleaseRequestFromJSONTyped(json, false);
}

export function LinkReleaseRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): LinkReleaseRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'releaseId': json['release_id'],
        'dateReleased': !exists(json, 'dateReleased') ? undefined : json['dateReleased'],
        'edgeId': !exists(json, 'edge_id') ? undefined : json['edge_id'],
        'releaseTitle': json['releaseTitle'],
        'releaseLabels': !exists(json, 'releaseLabels') ? undefined : json['releaseLabels'],
        'catNumbers': !exists(json, 'catNumbers') ? undefined : json['catNumbers'],
        'mediaType': !exists(json, 'mediaType') ? undefined : json['mediaType'],
        'format': !exists(json, 'format') ? undefined : json['format'],
    };
}

export function LinkReleaseRequestToJSON(value?: LinkReleaseRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'release_id': value.releaseId,
        'dateReleased': value.dateReleased,
        'edge_id': value.edgeId,
        'releaseTitle': value.releaseTitle,
        'releaseLabels': value.releaseLabels,
        'catNumbers': value.catNumbers,
        'mediaType': value.mediaType,
        'format': value.format,
    };
}

